import { render, staticRenderFns } from "./selectjob.vue?vue&type=template&id=025cd74d&scoped=true&"
import script from "./selectjob.vue?vue&type=script&lang=js&"
export * from "./selectjob.vue?vue&type=script&lang=js&"
import style0 from "./selectjob.vue?vue&type=style&index=0&id=025cd74d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025cd74d",
  null
  
)

export default component.exports